import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getInstitutionsDetails} from '../../actions';
import InstitutionsDetailsPlaceholder from './InstitutionsDetailsPlaceholder';
import InstitutionsDetails from './InstitutionsDetails';
import {withLocalize} from "react-localize-redux";

class InstitutionsDetailsContainer extends Component {
    fetchContent() {
        let slug = this.props.match.params.slug;

        this.props.getInstitutionsDetails(slug);
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps, prevState) {
        const {institutions, loading, errors} = this.props;

        if (prevProps.languages !== this.props.languages) {
            this.fetchContent();
        }

        if (prevProps.errors !== errors && !loading) {
            console.log(errors);

            if (errors.status === 303) {
                let uri = this.props.translate('routes.institutions_details').replace(':slug', errors.redirect);

                this.props.history.push(uri);
            }
        }

        if (!loading && institutions === {} && errors.status === 422) {
            setTimeout(() => {
                this.props.history.push('/404');
            }, 2000);
        }
    }

    render() {
        const {institutions, loading} = this.props;

        if (institutions === {} || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'institutions-details'
                        }}
                    >
                        <title>{process.env.REACT_APP_SITE_TITLE}</title>
                    </Helmet>
                    <div className="container">
                        <InstitutionsDetailsPlaceholder/>
                    </div>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'institutions-details'
                    }}
                >
                    <title>{(institutions.seo_title !== '' ? institutions.seo_title : institutions.title) + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {institutions.seo_meta_description !== '' &&
                        <meta name="description" content={institutions.seo_meta_description} />
                    }
                    {institutions.seo_facebook_og_title !== '' &&
                        <meta property="og:title" content={institutions.seo_facebook_og_title} />
                    }
                    {institutions.seo_facebook_og_description !== '' &&
                        <meta property="og:description" content={institutions.seo_facebook_og_description} />
                    }
                    {institutions.seo_facebook_og_image !== '' &&
                        <meta property="og:image" content={institutions.seo_facebook_og_image} />
                    }
                </Helmet>
                <div className="container">
                    <InstitutionsDetails institutions={institutions}/>
                </div>
            </Fragment>
        );
    }
}

InstitutionsDetailsContainer.propTypes = {
    getInstitutionsDetails: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    institutions: state.institutions.institutionsDetails,
    loading: state.institutions.institutionsDetailsLoading,
    errors: state.institutions.institutionsDetailsErrors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getInstitutionsDetails})(withLocalize(InstitutionsDetailsContainer)));



// WEBPACK FOOTER //
// ./src/features/Institutions/components/Details/InstitutionsDetailsContainer.js